import React from "react";
import "./ColumnSelector.css";

const ColumnSelector = ({ columnOrder, selectedColumns, onColumnSelect }) => {
  return (
    <div className="headerforColums">
      {/* <div className="select-columns">
        <h4>Select Columns:</h4>
      </div> */}
      <div className="columns-selected">
        {columnOrder.map((column, index) => (
          <label key={index} style={{ display: "flex", alignItems: "center" }}>
            <input
              className="checklist"
              type="checkbox"
              value={column}
              checked={selectedColumns.includes(column)}
              onChange={onColumnSelect}
            />
            <span style={{ marginLeft: "8px" }}>{column}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ColumnSelector;
